module.exports = __webpack_public_path__ + "img/0Q3A2940_L_Black_MockedUp.e3bb177f.jpg";